import React from 'react'
import { injectIntl } from 'react-intl'

// intl.locale
const LangWrapper = ({onSwitch, intl}) => (
  <div className="lang-wrapper">
    {intl.locale==='fi'?
      <span>fi</span>
      :
      <a href="/" onClick={(e) => {
        e.preventDefault();
        onSwitch();
      }}>fi</a>
    }
    ∫
    {intl.locale==='fi'?
      <a href="/" onClick={(e) => {
        e.preventDefault();
        onSwitch();
      }}>en</a>
      :
      <span>en</span>
    }
  </div>
)

export default injectIntl(LangWrapper);



// WEBPACK FOOTER //
// ./src/components/LangWrapper.js